export const INSTALL_TRACK_SOURCES = {
  INSTALL_TOP_BANNER: "install_top_banner",
  INSTALL_BUTTON: "install_button",
  DOWNLOAD_GAME_CARD: "download_game_card",
  DOWNLOAD_GATE_MODAL: "download_gate_modal",
  /** @deprecated Use ONLINE_PACKAGE_RETIREMENT_GATE. */
  PACKAGE_FORCE_GATE: "package_force_gate",
  // Keep the value stable so existing apk_download_* dashboards remain compatible.
  ONLINE_PACKAGE_RETIREMENT_GATE: "package_force_gate",
  POST_AUTH_INSTALL_PROMPT: "post_auth_install_prompt",
  LOGIN_REMIND_POPUP: "login_remind_popup",
  WITHDRAWAL_OFFICIAL_APP_PROMPT: "withdrawal_official_app_prompt",
} as const;

export type InstallTrackSource =
  (typeof INSTALL_TRACK_SOURCES)[keyof typeof INSTALL_TRACK_SOURCES];

export type EmEventName =
  | "kol_hall_arrival"
  | "auth_login_popup_view"
  | "auth_login_popup_close"
  | "auth_register_popup_view"
  | "auth_register_popup_close"
  | "auth_login_submit"
  | "auth_login_success"
  | "auth_login_fail"
  | "auth_register_submit"
  | "auth_register_success"
  | "auth_register_fail"
  | "wallet_recharge_submit"
  | "wallet_recharge_redirect_ready"
  | "wallet_recharge_fail"
  | "wallet_withdraw_submit"
  | "wallet_withdraw_success"
  | "wallet_withdraw_fail"
  | "apk_download_click"
  | "apk_install_entry_view"
  | "apk_install_entry_close"
  | "apk_transfer_payload_ready"
  | "apk_transfer_payload_fail"
  | "apk_download_redirect"
  | "apk_restore_success"
  | "apk_restore_fail"
  | "apk_download_gate_view"
  | "apk_download_gate_click"
  | "online_package_retirement_gate_decision"
  | "online_package_retirement_gate_view"
  | "online_package_retirement_gate_download_click"
  // Legacy names are dual-tracked during the compatibility window.
  | "package_force_gate_view"
  | "package_force_gate_download_click"
  | "apk_post_auth_prompt_view"
  | "apk_post_auth_prompt_click"
  | "withdraw_official_app_prompt_view"
  | "withdraw_official_app_prompt_continue"
  | "withdraw_official_app_prompt_dismiss"
  | "withdraw_official_app_prompt_snooze"
  | "home_widget_click"
  | "home_widget_toggle_click"
  | "activity_detail_view"
  | "activity_detail_click"
  | "activity_detail_tab_click"
  | "activity_detail_modal_view"
  | "activity_detail_modal_close"
  | "activity_detail_claim_submit"
  | "activity_detail_claim_success"
  | "activity_detail_claim_fail"
  | "recharge_spin_entry_view"
  | "recharge_spin_entry_click"
  | "recharge_spin_activity_view"
  | "recharge_spin_activity_close"
  | "recharge_spin_deposit_click"
  | "recharge_spin_rules_view"
  | "recharge_spin_rules_close"
  | "recharge_spin_click"
  | "recharge_spin_submit"
  | "recharge_spin_success"
  | "recharge_spin_fail"
  | "recharge_spin_result_close";

export type EmTrackPrimitive =
  | string
  | number
  | boolean
  | null
  | undefined;

export type EmTrackProps = Record<string, EmTrackPrimitive>;

export interface PendingEmTrackEvent {
  eventName: EmEventName;
  props: EmTrackProps;
}

export interface OpenInstallLinkTrackOptions {
  source?: InstallTrackSource;
  fromRegisterFlow?: boolean;
}
